/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const CreateContentResponse = zod.object({
  created: zod.array(
    zod.object({
      clientId: zod.string(),
      lineageUuid: zod
        .uuid()
        .describe(
          'Stable lineage uuid of the created node (survives re-versioning; navigate\/reload by this).',
        ),
      uuid: zod.uuid().describe('UUID v4 identifier'),
    }),
  ),
  idempotent: zod.boolean(),
  rootLineageUuid: zod.string().describe('Resolved stable lineage UUID of the root (first) node.'),
  rootUuid: zod.string().describe('Resolved version UUID of the root (first) node.'),
});

export type CreateContentResponse = zod.input<typeof CreateContentResponse>;
export type CreateContentResponseOutput = zod.output<typeof CreateContentResponse>;
